module.exports = {
  schema: {
    name: 'C-系列',
    type: 'Object',
    contents: {
      ragicId: {
        type: 'Number',
        ragicId: '_ragicId',
        name: 'RagicId',
        disabled: true,
      },
      key: {
        type: 'String',
        name: 'C-系列',
        ragicId: '1000234',
      },
      brandRef: {
        type: 'ObjectId',
        reference: 'brands',
        refKeys: ['key'],
        input: 'select',
        name: '品牌',
        ragicId: '1000128',
      },
      description: {
        type: 'String',
        ragicId: '1000504',
        name: '描述',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'brandRef', width: 130 },
        { key: 'description', width: 300 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '系列資料',
          rows: [
            [{ key: 'key' }],
            [{ key: 'brandRef' }],
            [{ key: 'description' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/serieses.js